// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3LFDG","loader":"Loader_loader__1j2Bs","load":"Loader_load__3_f_r","round":"Loader_round__2U8xM"};